import { useState, useEffect } from 'react';
import { setLanguage } from '../../lang';
import "../../variables.css";

const LangugageSelector = (props) => {
    const languages = [
        { title: 'En', value: 'en', id: 0 },
        { title: 'Hi', value: 'hi', id: 1 }
    ]

    const { styleProp } = props || '';

    const [ selectLang, setSelectLang ] = useState("en");

    useEffect(() => {
        setSelectLang(window.localStorage.getItem("lang") || "en");
    }, [])

    return (
        <div>
            <select value={selectLang} onChange={ (e) => { setSelectLang(e.target.value); setLanguage(e.target.value)} } style={ styleProp }>
                {
                    languages.map((lang) => {
                        return (<option key={ lang.id } style={{color : 'var(--text-color)'}} value={ lang.value }>{ lang.title }</option>
                    )})
                }
            </select>
        </div>
    )
}

export default LangugageSelector;